export const ACCOUNT = 'account';
export const SIGNUP = 'signup';
export const SIGNIN = 'signin';
export const SIGNUP_VERIFICATION = 'verify-signup-otp';
export const SIGNUP_VERIFICATION_CONFIRMATION =
  'signup-verification-confirmation';
export const SIGNIN_VERIFICATION = 'verify-signin-otp';
export const CHANGE_PASSWORD = 'change-password';
export const CHANGE_PASSWORD_VERIFICATION_CONFIRMATION =
  'change-password-verification-confirmation';
export const FORGOT_PASSWORD = 'forgot-password';
export const FORGOT_PASSWORD_NOTIFICATION = 'forgot-password-notification';
export const LOGOUT = 'logout';

export const DASHBOARD = 'dashboard';
export const USER_MANAGEMENT = 'user-management';
export const DRIVER_INFORMATION = 'user-management/driver-information';
export const DRIVER_INFORMATION_PROFILE =
  'user-management/driver-information/profile';
export const DRIVER_OVERALL_PERFORMANCE = 'overall-driver-performance';
export const BUSINESS_PROFILE = 'user-management/business-profile';
export const PERFORMANCE_MONITORING = 'performance-monitoring';
export const PERFORMANCE_MONITORING_VIEW_PERFORMANCE =
  'performance-monitoring/view-performance';
export const PERFORMANCE_MONITORING_SEARCH_RESULTS =
  'performance-monitoring/search-results';
export const PERFORMANCE_MONITORING_SEARCH_RESULTS_CONFLICT_DETAILS =
  'performance-monitoring/search-results/conflict-details';
export const REVENUE = 'revenue';
export const REVENUE_PRICE_MANAGEMENT = 'revenue/price-management';
export const KYC_COMPLIANCE = 'kyc-compliance';
// export const COMPANY_INSIGHTS = 'driver-history';
export const COMPANY_INSIGHTS = 'company-insights';
export const COMPANY_INSIGHTS_SEARCH_RESULTS = 'company-insights/results';
export const COMPANY_INSIGHTS_DRIVER_LIST = 'company-insights/driver-list';
export const COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES =
  'company-insights/driver-list/past-companies';
export const COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES_CONFLICT_DETAILS =
  'company-insights/driver-list/past-companies/conflict-details';
export const NOTIFICATIONS = 'notifications';
export const WAITLIST_SUBMISSIONS = 'waitlist-submissions';
export const DEMO_REQUESTS = 'demo-requests';

// NotFound
export const NOTFOUND = '404';
export const ACCESS_DENIED = 'access-denied';
export const BA_TRACKING = 'ba-tracking';
export const BA_DRIVER_VERIFICATION = 'ba-driver-verification';
export const BA_DRIVER_VERIFICATION_VIEW_COMPLAINT_SALES_ADMIN =
  'ba-driver-verification/view-complaint-sales-admin';
export const BA_DRIVER_VERIFICATION_SUPER_ADMIN = 'sa-ba-driver-verification';
